import {
  eventMatchesAway,
  eventMatchesHome,
  getMatchTeamRefs,
} from './matchTeamRefUtils';

function resolveLineupEntry(lineups, refs, side) {
  if (!Array.isArray(lineups) || lineups.length === 0) return null;

  const first = lineups[0];
  if (first?.homeTeam || first?.awayTeam) {
    const bundle =
      side === 'home'
        ? (Array.isArray(first.homeTeam) ? first.homeTeam[0] : first.homeTeam)
        : (Array.isArray(first.awayTeam) ? first.awayTeam[0] : first.awayTeam);
    return bundle ?? null;
  }

  if (side === 'home') {
    return lineups.find((entry) => eventMatchesHome(entry?.teamId, refs)) ?? lineups[0] ?? null;
  }

  return (
    lineups.find((entry) => eventMatchesAway(entry?.teamId, refs)) ??
    lineups.find((entry) => !eventMatchesHome(entry?.teamId, refs)) ??
    lineups[1] ??
    null
  );
}

/**
 * Reemplaza `formation` en `fixtures.data.lineups` según eventos `lineup.confirmed` del stream.
 *
 * @param {object[]} lineups — copia mutable de `fixtures.data.lineups`
 * @param {object[]} streamEvents — `events` de la respuesta actual de live-events
 * @param {object[]} [matchCard]
 * @returns {boolean} true si se actualizó al menos una formación
 */
export function applyLineupConfirmedFormationsFromStream(lineups, streamEvents, matchCard) {
  if (!Array.isArray(lineups) || lineups.length === 0) return false;
  if (!Array.isArray(streamEvents) || streamEvents.length === 0) return false;

  const refs = getMatchTeamRefs(matchCard?.[0]?.summary?.matchDetails);
  let changed = false;

  streamEvents.forEach((event) => {
    if (event?.eventType !== 'lineup.confirmed') return;

    const formation = event?.payload?.currentLineup?.formation;
    if (formation == null || String(formation).trim() === '') return;

    const teamLabel = event?.payload?.team;
    let target = null;

    if (teamLabel === 'HOME_TEAM') {
      target = resolveLineupEntry(lineups, refs, 'home');
    } else if (teamLabel === 'AWAY_TEAM') {
      target = resolveLineupEntry(lineups, refs, 'away');
    }

    if (!target) return;

    const nextFormation = String(formation).trim();
    if (target.formation !== nextFormation) {
      target.formation = nextFormation;
      changed = true;
    }
  });

  return changed;
}
